import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Content from '../components/content';
import { withDefaultStyles } from '../utils/material-ui/hoc';

class MainContent extends React.Component<any, any> {
  public render() {
    return (
      <div style={this.props.style}>
        <Content>
          {this.props.children}
        </Content>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(MainContent)));



// WEBPACK FOOTER //
// ./src/containers/main-content.tsx